import { css } from 'emotion'

export const ImageIconStyles = css``
